<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

div::-webkit-scrollbar {
  display: none;
  width: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

* {
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue